import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { IAccount } from '../model/UserModel';

export const accountsApi = createApi({
  reducerPath: 'accounts',
  baseQuery:   baseQuery({
    baseUrl: '/accounts/',
  }),
  tagTypes:    ['Account'],
  endpoints:   (build) => ({
    getAccountById: build.query<IAccount, string>({
      query:        (_id) => (
        {
          url:    `get`,
          method: 'POST',
          body:   {
            id: _id,
          },
        }),
      providesTags: (result, error, _id) => [{
        type: 'Account',
        _id,
      }],
    }),
    getAccounts:    build.query<IAccount[], void>({
      query:        () => (
        {
          url:    `list`,
          method: 'GET',
        }),
      providesTags: [{ type: 'Account' }],
    }),
    getAllAccounts: build.query<IAccount[], void>({
      query:        () => (
        {
          url:    `list_all`,
          method: 'GET',
        }),
      providesTags: [{ type: 'Account' }],
    }),
    updateAccount:  build.mutation<IAccount, Partial<IAccount>>({
      query:           (data) => ({
        url:    `edit`,
        method: 'POST',
        body:   data,
      }),
      invalidatesTags: (result, error, { _id }) => [{
        type: 'Account',
        _id,
      }],
    }),
    addAccount:     build.mutation<IAccount, IAccount>({
      query:           ({
                          _id,
                          ...data
                        }) => ({
        url:    'add',
        method: 'POST',
        body:   data,
      }),
      invalidatesTags: [{ type: 'Account' }],
    }),
    deleteAccount:  build.mutation<{ success: boolean; _id: string }, string>({
      query:           (_id) => (
        {
          url:    `delete`,
          method: 'POST',
          body:   {
            id: _id,
          },
        }),
      invalidatesTags: (result, error, _id) => [{
        type: 'Account',
        _id,
      }],
    }),
  }),
});

export const {
               useGetAccountByIdQuery,
               useGetAccountsQuery,
               useUpdateAccountMutation,
               useAddAccountMutation,
               useDeleteAccountMutation,
               useGetAllAccountsQuery,
             } = accountsApi;
